import Loader from '@anm/components/Loader';
import { FC } from 'react';
import styled from 'styled-components';

const LoaderWrapper = styled(Loader)`
  margin-top: 100px;
`;

const VideoFoldersLoader: FC = () => (
  <LoaderWrapper size="large" color="blue" />
);

export default VideoFoldersLoader;
